<div class="unauthorized-container">
  <mat-card>
    <mat-card-header>
      <mat-icon mat-card-avatar color="warn">block</mat-icon>
      <mat-card-title>Zugriff verweigert</mat-card-title>
      <mat-card-subtitle>Sie haben keine Berechtigung für diese Seite</mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="goBack()">
        Zurück zum Dashboard
      </button>
    </mat-card-actions>
  </mat-card>
</div>
